'use strict'
// docs: https://github.com/mzabriskie/axios
import axios from 'axios'
import qs from 'qs'
import config from '../../config'
import router from './../../router'
import store from './../../vuex/store'
import * as types from '../types/index'

axios.defaults.baseURL = config.ajaxBaseUrl

// 全局响应处理放这里
axios.interceptors.response.use((res) => {
  if (Number(res.data.code) === 999) {
    // store.dispatch(types.SET_FAIL_MESSAGE, {
    //   show: true,
    //   content: 'please login or login again'
    // })
    store.commit(types.SET_USER, {})
    router.push('/login')
  }
  return res
})

// 留个空行分割比较好看懂吧
/* eslint-disable no-trailing-spaces */
export default {
  getApplicationFiles(applicationId) {
    return axios.get("https://api-staging.amcredit.com/apply/getFiles?id=" + applicationId)
  },

  // 获取首页信息，包括页头页脚用到的公司信息和首页的热门产品数据
  getIndexInfo () {
    return axios.get('/cmsform/site/cmssitemenucontent/getMdIndexConfig.ht')
  },

  /*
   * 获取产品列表
   * @param params {Object} 接口参数
   * */
  getProductList (params) {
    return axios.get('/loanform/base/loanBaseProduct/getLoanProductList.ht', {
      headers: {
        tokenId: params.token
      },
      params: {
        pageCurrent: params.pageCurrent,
        proCategoryValue: params.proCategoryValue
      }
    })
  },

  /*
   * 获取产品详情
   * @param params {Object} 接口参数
   * */
  getProductDetail (params) {
    return axios.get('/loanform/base/loanBaseProduct/getLoanProductDetail.ht', {
      params: {
        productId: params.productId
      }
    })
  },

  /*
   * 当前用户是否在黑名单内
   * @param params {Object} 接口参数
   * */
  isCurrentUserInBlacklist (params) {
    return axios.get('/mobile/item/loanItemFrontApply/checkCustomerIsBlack.ht', {
      headers: {
        tokenId: params.token
      },
      params: {
        productId: params.productId
      }
    })
  },

  /*
   * 银行卡协议
   * */
  bankCardContract () {
    return axios.post('/cmsform/site/cmssitemenucontent/getBankCardContract.ht')
  },

  /*
   * REGISTRATION协议
   * */
  registerContract () {
    //return axios.get('/cmsform/site/cmssitemenucontent/getRegisterContract.ht')
    return axios.get('/cmsform/site/cmssitemenucontent/mgxyRegisterContract.ht',{ //注册协议 跟App一致 hgwn  4/15
      params: {
        contentTag: 'termsConditions'
      }
    })
  },

  /*
   * 用户REGISTRATION
   * @param params {Object} 接口参数
   * */
 /* userRegister (params) {
    return axios.get('/crmform/customer/crmCustomer/register.ht', {
      params: {
        customerLoginName: params.customerLoginName,
        customerLoginPwd: params.customerLoginPwd,
        validCode: params.validCode,
        customerType: params.customerType
      }
    })
  },*/

  brokerRegisterUser (params) {
    return axios({url: '/crmform/customer/crmCustomer/mgxyRegisterBroker.ht', method: 'post', data: params,
      transformRequest: [function (data) {
        let ret = ''
        for (let it in data) {
          ret += encodeURIComponent(it) + '=' + encodeURIComponent(data[it]) + '&'
        }
        return ret
      }],
      headers: {
        'Content-Type': 'application/x-www-form-urlencoded'
      }
    })

  }, 

  userRegister (params) {
    return axios({url: '/crmform/customer/crmCustomer/mgxyRegister.ht', method: 'post', data: params,
      transformRequest: [function (data) {
        let ret = ''
        for (let it in data) {
          ret += encodeURIComponent(it) + '=' + encodeURIComponent(data[it]) + '&'
        }
        return ret
      }],
      headers: {
        'Content-Type': 'application/x-www-form-urlencoded'
      }
    })

  },


  /*
   * 用户登录
   * @param params {Object} 接口参数
   * */
  /*userLogin (params) {
    return axios.get('/crmform/customer/crmCustomer/login.ht', {
      params: {
        loginName: params.loginName,
        password: params.password
      }
    })
  },*/

  userLogin (params) {
    return axios({url: '/crmform/customer/crmCustomer/mgxyLogin.ht', method: 'post', data: {
      loginName: params.loginName,
      password: params.password
    },
      transformRequest: [function (data) {
        let ret = ''
        for (let it in data) {
          ret += encodeURIComponent(it) + '=' + encodeURIComponent(data[it]) + '&'
        }
        return ret
      }],
      headers: {
        'Content-Type': 'application/x-www-form-urlencoded'
      }
    })

  },

  /*
   * Broker登录
   * @param params {Object} 接口参数
   * */
  brokerLogin (params) {
    return axios({url: '/crmform/customer/crmCustomer/mgxyBrokerLogin.ht', method: 'post', data: {
      loginName: params.loginName,
      password: params.password
    },
      transformRequest: [function (data) {
        let ret = ''
        for (let it in data) {
          ret += encodeURIComponent(it) + '=' + encodeURIComponent(data[it]) + '&'
        }
        return ret
      }],
      headers: {
        'Content-Type': 'application/x-www-form-urlencoded'
      }
    })

  },


  /*
   * 用户注销
   * */
  userLogout () {
    return axios.get('/crmform/customer/crmCustomer/exit.ht')
  },

  /*
   * 验证图形验证码
   * @param params {Object} 接口参数
   * */
  validateImageVerificationCode (params) {
    return axios.get('/crmform/customer/crmCustomer/checkValidCode.ht', {
      params: {
        validCode: params.validCode
      }
    })
  },

  /*
   * 验证旧密码是否正确
   * @param params {Object} 接口参数
   * */
  validateOldLoginPassword (params) {
    return axios.get('/crmform/customer/crmCustomer/checkPassword.ht', {
      headers: {
        tokenId: params.token
      },
      params: {
        password: params.password
      }
    })
  },

  /*
   * 获取短信验证码
   * @param params {Object} 接口参数
   * */
  getSMSVerificationCodeForForgetPassword (params) {
    return axios.post('/crmform/customer/crmCustomer/getValidcode.ht', qs.stringify({
      mobile: params.mobile,
      isForRegister: params.isForRegister === true ? '1' : '0'
    }))
  },

  getSMSVerificationCode (params) {
    return axios.get('/crmform/customer/crmCustomer/mgxyGetValidcodeByMobile.ht', {
      params: {
        mobile: params.mobile,
        isForRegister: params.isForRegister === true ? '1' : '0'
      }
    })
  },
  
  getSMSVerificationCodeForSign (params) {
	    return axios.get('/crmform/customer/crmCustomer/mgxySendSmsCode.ht', {
	        params: {
	          mobile: params.mobile
	        }
	      })	  
  },
	
	  getSMSForEmail (params) {
		    return axios.post('/crmform/customer/crmCustomer/mgxyForgetPwdSendEmail.ht', qs.stringify({
		        	email: params.email,
		      }))	  
	}, 
  
  getSMSVerificationCodeForEmail (params) {
	    return axios.get('/crmform/customer/crmCustomer/mgxySendEmailCode.ht', {
	        params: {
	        	email: params.email,
	        	type: 'registered',
	        	isForRegister: '0'
	        },
	        headers:{"tokenId":params.tokenId}
	      })	  
},  

getSMSVerificationCodeForEmailRegister (params) {
  return axios.get('/crmform/customer/crmCustomer/mgxySendEmailCode.ht', {
      params: {
        email: params.email,
        type: 'unregistered',
        isForRegister: '1'
      },
      headers:{"tokenId":params.tokenId}
    })	  
},

  ///


  /*
   * 忘记密码
   * @param params {Object} 接口参数
   * */
  // forgetPassword (params) {
  //   return axios.get('/crmform/customer/crmCustomer/mgxyForgetPwd.ht', {
  //     params: {
  //       mobile: params.mobile,
  //       validCode: params.validCode,
  //       password: params.password
  //     }
  //   })
  // },

  forgetPassword(params){
    return axios({url: '/crmform/customer/crmCustomer/mgxyForgetPwd.ht', method: 'post', data: params,
      transformRequest: [function (data) {
        let ret = ''
        for (let it in data) {
          ret += encodeURIComponent(it) + '=' + encodeURIComponent(data[it]) + '&'
        }
        return ret
      }],
      headers: {
        'Content-Type': 'application/x-www-form-urlencoded'
      }
    })
  },

  /*
   * 个人信息，读取 <-实名认证->
   * @param params {Object} 接口参数
   * */
  getPersonalInfo (params) {
    return axios.get('/crmform/customer/crmCustomer/getPersonInformation.ht', {
      headers: {
        tokenId: params.token
      },
      params: {
        customerId: params.customerId
      }
    })
  },

  /*
   * 个人信息初始化getPersonalInitData
   * @param params {Object} 接口参数
   * */
  getPersonalInitData (params) {

     return axios.get('/crmform/customer/crmCustomer/mgxyCustomerDetail.ht', {


    // return axios.get('/crmform/customer/crmCustomer/getPersonInformationDetail.ht', {
      headers: {
        tokenId: params.token
      },
      params: {
        customerId: params.customerId
      }
    })
  },

  /*
   * 个人信息初始化getClientData
   * @param params {Object} 接口参数
   * */
  getClientData (params) {

    return axios.get('/crmform/customer/crmCustomer/mgxyClientCustomerDetail.ht', {


   // return axios.get('/crmform/customer/crmCustomer/getPersonInformationDetail.ht', {
     headers: {
       tokenId: params.token
     },
     params: {
       customerId: params.customerId
     }
   })
 },

  /*
   * 个人信息-实名认证，保存
   * @param params {Object} 接口参数
   * */
  savePersonalInfo (params) {
    return axios.get('/mobile/crmCustomerPersonInfoController/saveAndUpdatePersonalInfoMd.ht', {
      headers: {
        tokenId: params.token
      },
      params: {
        customerId: params.customerId,
        customerName: params.customerName,
        personIdentityCard: params.personIdentityCard
      }
    })
  },

  /*
   * 个人信息-个人信息，保存
   * @param params {Object} 接口参数
   * */
  savePersonalInfoall (params) {
    return axios.get('/mobile/crmCustomerPersonInfoController/saveAndUpdatePersonalInfoDetailMd.ht', {
      headers: {
        tokenId: params.token
      },
      params: {
        personSex: params.personSex,
        personBirthDate: params.personBirthDate,
        personEducation: params.personEducation,
        personCollege: params.personCollege,
        a: params.a,
        personCategory: params.personCategory,
        personCensusAddr: params.personCensusAddr,
        personMarital: params.personMarital,
        personFamily: params.personFamily,
        personExistChild: params.personExistChild,
        personHouse: params.personHouse,
        b: params.b,
        personDwellAddr: params.personDwellAddr,
        personCompanyName: params.personCompanyName,//工作单位全称
        personCompanyAddr: params.personCompanyAddr,
        personCompanyTime: params.personCompanyTime,
        personCompanyPost: params.personCompanyPost,
        personCompanyPhone: params.personCompanyPhone,
        personCompanyNature: params.personCompanyNature,
        personCompanyLinkman: params.personCompanyLinkman,
        personCompanyLinkmanPhone: params.personCompanyLinkmanPhone,
        personYearIncome: params.personYearIncome,
        personCompanyAge: params.personCompanyAge,
        personSocialSecurityTime: params.personSocialSecurityTime
      }
    })
  },


  /*
   * 企业信息，读取；目前暂时与个人信息接口通用，以后有修改的可能性
   * @param params {Object} 接口参数
   * */
  getEnterpriseInfo (params) {
    return axios.get('/mobile/crmCustomerCompanyInfoController/getCompanyInfo.ht', {
      headers: {
        tokenId: params.token
      },
      params: {
        customerId: params.customerId
      }
    })
  },

  /*
   * 企业信息，保存；目前暂时与个人信息接口通用，以后有修改的可能性
   * @param params {Object} 接口参数
   * */
  saveEnterpriseInfo (params) {
    return axios.get('/mobile/crmCustomerCompanyInfoController/saveAndUpdateCompanyInfo.ht', {
      headers: {
        tokenId: params.token
      },
      params: {
        customerId: params.customerId,
        customerName: params.customerName,
        enterpriseNumber: params.enterpriseNumber,
        enterprisePartnerNumber: params.enterprisePartnerNumber,
        enterpriseRegAddr: params.enterpriseRegAddr,
        enterpriseType: params.enterpriseType,
        enterpriseRegMoney: params.enterpriseRegMoney,
        enterpriseLegalUser: params.enterpriseLegalUser,
        enterpriseLegalIdNo: params.enterpriseLegalIdNo,
        enterpriseLegalUserPhone: params.enterpriseLegalUserPhone,
        enterpriseOrganizingNumber: params.enterpriseOrganizingNumber,
        enterpriseScale: params.enterpriseScale,
        enterpriseNationalNumber: params.enterpriseNationalNumber,
        enterpriseGovernmentNumber: params.enterpriseGovernmentNumber,
        enterpriseRegOrgan: params.enterpriseRegOrgan,
        enterpriseEmployeeNum: params.enterpriseEmployeeNum,
        enterpriseScope: params.enterpriseScope,
        enterpriseFoundExplain: params.enterpriseFoundExplain,
        userType: params.userType,
        registrationType: params.registrationType
      }
    })
  },

  /*
   * 修改密码
   * @param params {Object} 接口参数
   * */
  // updatePassword (params) {
  //   return axios.get('/crmform/customer/crmCustomer/mgxyResetPassword.ht', {
  //     headers: {
  //       tokenId: params.token
  //     },
  //     params: {
  //       oldPwd: params.oldPwd,
  //       newPwd: params.newPwd
  //     }
  //   })
  // },

  updatePassword(params){
    return axios({url: '/crmform/customer/crmCustomer/mgxyResetPassword.ht', method: 'post', data: params,
      transformRequest: [function (data) {
        let ret = ''
        for (let it in data) {
          ret += encodeURIComponent(it) + '=' + encodeURIComponent(data[it]) + '&'
        }
        return ret
      }],
      headers: {
        'Content-Type': 'application/x-www-form-urlencoded'
      }
    })
  },


  /*
   * 获取流程第一步初始数据
   * @param params {Object} 接口参数
   * */
  getStep1InitialData (params) {
    return axios.get('/mobile/item/loanItemFrontApply/getLoanInformation.ht', {
      headers: {
        tokenId: params.token
      },
      params: {
        productid: params.productId
      }
    })
  },

  /*
   * 获取已保存的流程第一步数据
   * @param params {Object} 接口参数
   * */
  getSavedStep1Data (params) {
    return axios.get('/mobile/item/loanItemFrontApply/getIndentifyInformation.ht', {
      headers: {
        tokenId: params.token
      },
      params: {
        frontApplyId: params.frontApplyId
      }
    })
  },

  /*
 * 获取借款金额tan
 * */
  getLoanData () {
    return axios.get('/loanform/base/loanBaseProduct/productAll.ht')
  },

  getLoanDataCTL () {
    return axios.get('/loanform/base/loanBaseProduct/productCTL.ht?baseProductType=08')
  },

  getLoanDataSBL () {
    return axios.get('/loanform/base/loanBaseProduct/productCTL.ht?baseProductType=09')
  },

  /*
* 获取借款期限 Loan Term hgwn 4/16  跟姐看借款金额 select二级 联调，认为没有必要从vuex状态管理，获取数据！
* */
  getLoanLimitData(params){
    return axios.get('/loanform/base/loanBaseProduct/productByDefaultLimit.ht',{
      params: {
        money: params.money
      }
    })
  },

  /**
   * 获取贷款的利息
   * @param {long} productId 产品ID
   * @param {double} repayMoney 贷款金额
   * @param {int} payExpires 贷款期限
   * @param {int} payExpiresUnit 期限单位（1=年，2=月，3=日）
   */
  calculateInterest(params){
    return axios.get('/loanform/finance/loanItemFinancePay/calculateInterest.ht',{
      params: {
        productId: params.productId,
        money: params.money,
        expires: params.expires,
        payExpiresUnit: params.payExpiresUnit
      }
    })
  },

  mgxyBrokerApply (params){ // broker保存贷款申请
    return axios({url: '/mobile/item/loanItemFrontApply/mgxyBrokerApply.ht', method: 'post', data: params,
      transformRequest: [function (data) {
        let ret = ''
        for (let it in data) {
          ret += encodeURIComponent(it) + '=' + encodeURIComponent(data[it]) + '&'
        }
        return ret
      }],
      headers: {
        'Content-Type': 'application/x-www-form-urlencoded'
      }
    })
  },

  mgxyApply(params){ // 保存贷款申请 hgwn  postForm 跟App 一致接口 4/16
    return axios({url: '/mobile/item/loanItemFrontApply/mgxyApply.ht', method: 'post', data: params,
      transformRequest: [function (data) {
        let ret = ''
        for (let it in data) {
          ret += encodeURIComponent(it) + '=' + encodeURIComponent(data[it]) + '&'
        }
        return ret
      }],
      headers: {
        'Content-Type': 'application/x-www-form-urlencoded'
      }
    })
  },
  
  mgxyUpdateApplyForIdcard(params){
	  return axios({url: '/mobile/item/loanItemFrontApply/mgxyUpdateApplyForIdcard.ht', method: 'post', data: params})
  },
  mgxyUpdateApplyForDriverLicense(params){
	  return axios({url: '/mobile/item/loanItemFrontApply/mgxyUpdateApplyForDriverLicense.ht', method: 'post', data: params})
  },
  mgxyUpdateApplyForCitizenId(params){
	  return axios({url: '/mobile/item/loanItemFrontApply/mgxyUpdateApplyForCitizenId.ht', method: 'post', data: params})
  },

  mgxyDictionary(){ // Apply1 获取进件数字字典 信息 跟App 一致接口 hgwn
    return axios.get('/mobile/item/loanItemFrontApply/mgxyDictionary.ht', {
      params: {
        nodes: 'mgxy_city,mgxy_state,mgxy_income_source,mgxy_pay_frequency,mgxy_bank_state,mgxy_education,mgxy_marital_tatus,mgxy_title,mgxy_document_type'
      }
    })
  },

  mgxyGetPersonDetails(params){ // Apply1 获取进件用户信息 跟App 一致接口 hgwn
    return axios.get('/mobile/item/loanItemFrontApply/mgxyGetPersonDetails.ht', {
      params: {
        tokenId: params.token,
        frontApply: params.frontApply,
        customerId: params.customerId
      }
    })
  },

  postForm(url,params){ //  hgwn  postForm 4/16
    return axios({url: url, method: 'post', data: params,
      transformRequest: [function (data) {
        let ret = ''
        for (let it in data) {
          ret += encodeURIComponent(it) + '=' + encodeURIComponent(data[it]) + '&'
        }
        return ret
      }],
      headers: {
        'Content-Type': 'application/x-www-form-urlencoded'
      }
    })
  },
  postPlaid(url,params){ //  hgwn  postForm 4/16
    return axios({url: url, method: 'post', data: params,
      transformRequest: [function (data) {
        let ret = ''
        for (let it in data) {
          ret += encodeURIComponent(it) + '=' + encodeURIComponent(data[it]) + '&'
        }
        return ret
      }],
      headers: {
        'Content-Type': 'application/x-www-form-urlencoded'
      }
    })
  },
  
  get(url,params){ // get
    return axios.get(url, {
      params: params
    })
  },







  /*
   * 确认贷款弹窗数据
   * @param params {Object} 接口参数
   * */
  getConfirmLoanData (params) {
    return axios.get('/loanform/finance/loanItemFinancePay/generateTemporaryRepayData.ht', {
      headers: {
        tokenId: params.token
      },
      params: {
        productId: params.productId,
        repayType: params.repayType,
        repayMoney: params.money,
        payExpires: params.expires,
        payExpiresUnit: params.expiresUnit
      }
    })
  },

  /*
   * 保存流程第一步数据
   * @param params {Object} 接口参数
   * */
  saveStep1FormData (params) {
    return axios.post('/mobile/item/loanItemFrontApply/add.ht', qs.stringify({
      frontApplyCustomerType: params.customerType,
      frontApplyMoney: params.money,
      frontApplyExpires: params.expires,
      frontApplyExpiresUnit: params.expiresUnit,
      frontApplyRepayType: params.repayType,
      frontApplyProductName: params.productName,
      frontApplyProductId: params.productId
    }), {
      headers: {
        tokenId: params.token
      }
    })
  },

  /*
   * 保存流程进度
   * @param params {Object} 接口参数
   * */
  saveApplyLoanProgress (params) {
    return axios.post('/mobile/item/loanItemFrontApply/updateApply.ht', qs.stringify({
      step: params.step,
      frontApplyId: params.frontApplyId,
      frontApplyMoney: params.money,
      frontApplyExpires: params.expires,
      frontApplyExpiresUnit: params.expiresUnit,
      frontApplyRepayType: params.repayType,
      frontApplyProductName: params.productName,
      frontApplyProductId: params.productId,
      bankAccountId: params.bankAccountId,
      gid: params.gid
    }), {
      headers: {
        tokenId: params.token
      }
    })
  },

  /*
   * 获取银行卡列表数据
   * @param params {Object} 接口参数
   * */
  getBankcardListData (params) {
    return axios.get('/mobile/crmCustomerBankAccountInfoController/getBankListMd.ht', {
      headers: {
        tokenId: params.token
      },
      params: {
        frontApplyId: params.frontApplyId
      }
    })
  },

  /*
   * 保存银行卡数据；用于保存和修改
   * @param params {Object} 接口参数
   * */
  saveBankcardInfo (params) {
    return axios.get('/mobile/crmCustomerBankAccountInfoController/saveBankInfoJL.ht', {
      headers: {
        tokenId: params.token
      },
      params: {
        customerId: params.customerId,
        bankType: params.bankType,
        bankUserName: params.bankUserName,
        bankAccountName: params.bankAccountName,
        bankName: params.bankName,
        bankBranchName: params.bankBranchName,
        bankAccountId: params.bankAccountId,
        bankCounty: params.bankCounty,
        bankProvince: params.bankProvince,
        bankCity: params.bankCity
      }
    })
  },

  /*
   * 删除银行卡
   * @param params {Object} 接口参数
   * */
  deleteBankcardInfo (params) {
    return axios.post('/mobile/crmCustomerBankAccountInfoController/deleteBankAccount.ht', qs.stringify({
      bankAccountId: params.bankAccountId
    }), {
      headers: {
        tokenId: params.token
      }
    })
  },

  /*
   * 获取银行可选列表，用于开户银行模糊查询
   * @param params {Object} 接口参数
   * */
  getBankcardSelectData (params) {
    return axios.get('mobile/crmCustomerBankAccountInfoController/searchBankList.ht', {
      headers: {
        tokenId: params.token
      },
      params: {
        bankName: params.bankName,
        limit: params.limit
      }
    })
  },

  /*
   * 查询可选省份
   * */
  getProvinceData () {
    return axios.get('/loanform/item/region/getProvince.ht')
  },

  /*
   * 查询可选城市和区县
   * @param params {Object} 接口参数
   * */
  getCityAndDistrictData (params) {
    return axios.get('/loanform/item/region/getCityOrCounty.ht', {
      params: {
        code: params.code
      }
    })
  },

  /*
   * 保存上传文件
   *  @param params {Object} 接口参数
   * */
  saveUploadFile (params) {
    // 后台那边不知道什么问题，第二层开始的json解析不能，必须这样序列化一下
    return axios.post('/mobile/crmCustomerAttachInfoController/saveCustomerFileList.ht', qs.stringify({
      customFileArray: JSON.stringify(params.files)
    }), {
      headers: {
        tokenId: params.token
      }
    })
  },

  /*
   * 删除上传文件
   *  @param params {Object} 接口参数
   * */
  deleteUploadedFile (params) {
    return axios.post('/platform/system/sysFile/delByFileId.ht', qs.stringify({
      ids: params.id
    }), {
      headers: {
        tokenId: params.token
      }
    })
  },

  getFileIds(params){
	    return axios.get('/crmform/customer/crmCustomer/mgxyCustomerDetail.ht', {
	        params: {
	        	tokenId: params.token
	        }
	      })	  
  },
  
  /*
   * 获取文件上传列表
   *  @param params {Object} 接口参数
   * */
  getFileUploadList (params) {
    return axios.get('/mobile/crmCustomerAttachInfoController/queryAttachListMd.ht', {
      headers: {
        tokenId: params.token
      },
      params: {
        frontApplyId: params.frontApplyId
      }
    })
  },

  /*
   * 获取还款计划详情接口
   * @param params {Object} 接口参数
   * */
  getRepayPlanDetail (params) {
    return axios.get('/loanform/finance/loanItemFinanceRepay/getRepayPlanDetail.ht', {
      params: {
        financePayId: params.financePayId,
        financePayPeriod: params.financePayPeriod,
        pageCurrent: params.pageCurrent,
        pageSize: params.pageSize,
        repayStatusCode: params.repayStatusCode
      }
    })
  },

  /*
   * 获取我的贷款列表接口
   * @param params {Object} 接口参数
   * */
  getMyLoanData (params) {
    return axios.get('/mobile/item/loanItemFrontApply/getMyLoanDataMd.ht', {
      headers: {
        tokenId: params.token
      },
      params: {
        frontApplyState: params.frontApplyState,
        pageCurrent: params.pageCurrent
      }
    })
  },

  /*
   * 获取我的贷款列表接口
   * @param params {Object} 接口参数
   * */
  getBrokerLoanData (params) {
    return axios.get('/mobile/item/loanItemFrontApply/getBrokerLoanDataMd.ht', {
      headers: {
        tokenId: params.token
      },
      params: {
        frontApplyState: params.frontApplyState,
        pageCurrent: params.pageCurrent
      }
    })
  },

    /*
   * 根据frontApplyId获取Client的customerId
   * @param params {Object} 接口参数
   * */
  getClientApply (params) {
    return axios.get('/mobile/item/loanItemFrontApply/mgxyGetClientApply.ht', {
      headers: {
        tokenId: params.token
      },
      params: {
        frontApplyId: params.frontApplyId,
      }
    })
  },

  /*
   * 获取我的贷款详情接口接口
   * @param params {Object} 接口参数
   * 后台需要，添加一个贷款审核状态参数
   * */
  getMyLoanDetail (params) {
    return axios.get('/mobile/item/loanItemFrontApply/getMyLoanDetailMd.ht', {
      headers: {
        tokenId: params.token
      },
      params: {
        frontApplyId: params.frontApplyId,
        pageCurrent: params.pageCurrent,
        pageSize: params.pageSize,
        frontItemApplyState: params.frontItemApplyState
      }
    })
  },

  /*
   * 电子合同客户签名接口
   * @param params {Object} 接口参数
   * */
  signAgreement (params) {
  	var fullName = params.fullName;
	var nameArr = fullName.split(" ");
	var firstName = nameArr[0];
	var middleName = "";
	var lastName = "";
	if(nameArr.length>2){
		middleName = nameArr[1];
		lastName = nameArr[2];
	}else{
		lastName = nameArr[1];
	}	  
    return axios.post('/mobile/item/loanItemFrontApply/mgxyConfirmSignContract.ht', {
      params: {
    	tokenId: params.token,
    	contractId: params.contractId,
    	mobile: params.mobile,
    	validCode: params.validCode,
    	firstName: params.firstName,
    	middleName: params.middleName,
    	lastName: params.lastName
      }
    })
  },

  /*
   * 下载电子合同接口
   * @param params {Object} 接口参数
   * */
  downAgreement (params) {
    return axios.get('/mobile/item/pdfSignatureController/readContract.ht', {
      params: {
        download: true,
        fileType: 'PDF',
        identify: '01',
        isOverseasCustome: 'N',
        loanItemApplyId: params.itemApplyId,
        itemContractSigned: params.itemContractSigned,
        id: Math.random()
      }
    })
  },

  /*
   * 删除我的贷款项（单个）
   * @param params {Object} 接口参数
   * */
  deleteLoanItemFrontApply (params) {
    return axios.post('/mobile/item/loanItemFrontApply/deleteLoanRecord.ht',
      qs.stringify({
        frontApplyId: params.frontApplyId,
        itemApplyId: params.itemApplyId
      }),
      {
        headers: {
          tokenId: params.token
        }
      })
  },

  /*
   * 提前还款信息接口
   * @param params {Object} 接口参数
   * */
  getRepaymentInfo (params) {
    return axios.get('/loanform/finance/loanItemFinanceRepay/getMgxyAdvancedRepayInfo.ht', {
      headers: {
        tokenId: params.token
      },
      params: {
        itemApplyId: params.itemApplyId,
        frontItemApplyState: params.frontItemApplyState
      }
    })
  },

    /*
   * 保存流程第一步数据
   * @param params {Object} 接口参数
   * */
  getPartPrepaymentMoney (params) {
    return axios.post('/loanform/finance/loanItemFinanceRepayApproval/earlyOwingOnTheLoan.ht', {
      headers: {
        tokenId: params.token
      },
      params: {
        itemApplyId: params.itemApplyId,
        balancedPrincipal: params.balancedPrincipal,
        pay: params.pay
      }
    })
  },
  /*
   * 获取整期还款信息接口
   * @param params {Object} 接口参数
   * */
  getWholePeriodRepayInfo (params) {
    return axios.get('/loanform/finance/loanItemFinanceRepay/getWholePeriodRepayInfo.ht', {
      headers: {
        tokenId: params.token
      },
      params: {
        itemApplyId: params.itemApplyId,
        frontItemApplyState: params.frontItemApplyState
      }
    })
  },

  /*
   * 整期还款,确认还款接口
   * @param params {Object} 接口参数
   * */
  wholePeriodPayConfirm (params) {
    return axios.get('/loanform/finance/loanItemFinanceReceipt/wholePeriodPayConfirm.ht', {
      headers: {
        tokenId: params.token
      },
      params: {
        itemApplyId: params.itemApplyId
      }
    })
  },

  /*
   * 提前还款，确认还款接口
   * @param params {Object} 接口参数
   * */
  advanceConfirm (params) {
    return axios.get('/loanform/finance/loanItemFinanceReceipt/mgxyAdvanceConfirm.ht', {
      headers: {
        tokenId: params.token
      },
      params: {
    	tokenId: params.token,
        itemApplyId: params.itemApplyId
      }
    })
  },

  /*
   * 实名认证接口
   * @param params {Object} 接口参数
   * */
  authPersonInfo (params) {
    return axios.get('/mobile/bankAuthApplyController/authPersonInfo.ht', {
      headers: {
        tokenId: params.token,
        Token: params.token
      }
    })
  },

  /*
   * 实名认证发送短信验证码的接口
   * @param params {Object} 接口参数
   * 12/25确定调用新版App接口 hgwn
   * */
  authPersonSMSCode (params) {
    return axios.get('/paymentOrders/sendIndentifyCode.ht', {
      headers: {
        tokenId: params.token,
        Token: params.token
      },
      params: {
        customerId: params.customerId,
        proNumber: params.proNumber,
        bankAccount: params.bankAccount,
        bankAccountOwner: params.bankAccountOwner,
        mobile: params.mobile,
        idno: params.idno,
        msgType: params.msgType,
        Token: params.token
      }
    })
  },

  /*
   * 实名制接口
   * @param params {Object} 接口参数
   * 12/25确定调用新版App接口 hgwn
   * */
  authPersonSignAgreement (params) {
    return axios.get('/paymentOrders/confirmSign.ht', {
      params: {
        // proNumber: params.proNumber,
        bankAccount: params.bankAccount,
        bankAccountOwner: params.bankAccountOwner,
        idno: params.idno,
        customerId: params.customerId,
        vCode: params.vCode,
        indexCode: params.indexCode,
        Token: params.token
      }
    })
  },

  /*
   * 获取关于我们页面信息
   * */
  getAboutUsInfo () {
    return axios.get('/loan/backstage/tsettings/getAboutUsInformation.ht')
  },

  /*
   * 是否启用额度开关接口
   * */
  getEnableCreditQuotaSwitch () {
    return axios.get('/crmform/customer/userCredit/userCreditQuotaController/isEnableCreditQuotaSwitch.ht')
  },

  /*
   * 查看指定用户的指定产品的可用额度
   * @param params {Object} 接口参数
   * */
  getAvailableAmount (params) {
    return axios.get('/crmform/customer/userCredit/userCreditQuotaController/getAvailableAmount.ht', {
      params: {
        tokenId: params.tokenId,
        productId: params.productId
      }
    })
  },

  /*
   * 申请产品额度的接口
   * @param params {Object} 接口参数
   * */
  getApplicationQuota (params) {
    return axios.get('/crmform/customer/userCredit/userCreditQuotaController/applicationQuota.ht', {
      params: {
        tokenId: params.tokenId,
        productId: params.productId
      }
    })
  },

  /*
 * 获取企业实名制信息
 * @param params {Object} 接口参数
 * */
  getEnterpriseAuthInfo (params) {
    return axios.get('/mobile/bankAuthApplyController/authEnterpriseInfoForJL.ht', {
      headers: {
        tokenId: params.token
      }
    })
  },

  /*
* 提交企业实名制
* @param params {Object} 接口参数
* */
  saveEnterpriseAuthInfo (params) {
    return axios.get('/mobile/bankAuthApplyController/enterpriseAuthForJL.ht', {
      headers: {
        tokenId: params.token
      },
      params: {
        authId: params.authId,
        customerId: params.customerId,
        customerName: params.customerName,
        enterpriseNumber: params.enterpriseNumber,
        enterpriseLegalUser: params.enterpriseLegalUser,
        enterpriseLegalUserPhone: params.enterpriseLegalUserPhone
      }
    })
  },

  /*
* 获取加密公钥
* @param params {Object} 接口参数
* */
  generateRSAPublicKey (params) {
    return axios.get('/agent/generateRSAPublicKey.ht')
  },

  /**
   * 上传附件公共接口
   * @param {object} params
   */
  saveFileByBase64 (params) {
      console.log(params)
    return axios.post('/mobile/crmCustomerAttachInfoController/mgxySaveFileByBase64.ht', params, {
        headers: {
            tokenId: params.token
        }
    })
  }
}



// WEBPACK FOOTER //
// ./src/vuex/api/index.js